export default __webpack_public_path__ + "static/media/myclassroom-logo.7b93fa10.svg";